import { CursosService } from '@/app/core/services/cursos.service';
import { Actividad } from '@/app/models/interface/actividad.model';
import { Adjunto } from '@/app/models/interface/adjunto.model';
import { Capacitacion } from '@/app/models/interface/capacitacion.model';
import { Competencia } from '@/app/models/interface/competencia.model';

import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { driver } from 'driver.js';
import { Editor } from 'primeng/editor';
import Quill from 'quill';
import QuillResizeImage from 'quill-resize-image';
Quill.register('modules/imageResize', QuillResizeImage);

@Component({
  selector: 'c-resources',
  templateUrl: './resources.component.html',
  styleUrl: './resources.component.css',
  standalone: false,
})
export class ResourcesComponent implements OnInit {
  @Input() titulo!: string;
  @Input() descripcion!: string;

  error = false;

  @Input() text!: string;

  @Input() adjuntos: Adjunto[] = [];

  range!: { index: number; length: number };

  competencia!: Competencia;
  // subCompetencia!: SubCompetencia;
  actividad!: Actividad;
  @Input() capacitacionId!: string;

  capacitaciones: Capacitacion[] = [];
  capacitacion!: Capacitacion;
  private readonly cursoService = inject(CursosService);
  ngOnInit() {
    this.cursoService.registerInitCurso().subscribe((data) => {
      this.capacitaciones = data;

      if (this.capacitacionId) {
        const capacitacion = this.capacitaciones.find(
          ({ id }) => id == this.capacitacionId,
        );

        if (capacitacion) this.capacitacion = capacitacion;
      }
    });
  }

  initEditor = {
    module: {
      imageResize: {
        locale: {
          //altTip: 'Hold down the alt key to zoom',
          floatLeft: 'Izq',
          floatRight: 'Der',
          center: 'Cen',
          restore: 'Original',
        },
      },
    },
    formats: ['image', 'link'],
  };

  @ViewChild('editor') editor!: Editor;

  tour() {
    const driverObj = driver({
      nextBtnText: 'Sig.',
      prevBtnText: 'Ant.',
      doneBtnText: 'Fin.',
      allowKeyboardControl: true,
      disableActiveInteraction: true,
      showProgress: true,
      steps: [
        {
          element: '#titulo-resource',
          popover: {
            title: 'Crear material',
            description:
              'Aquí podrá agregar el título del material. Tenga en cuenta que no se podrá repetir el nombre con uno ya creado',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '#descripcion-resource',
          popover: {
            title: 'Crear material',
            description:
              'Le podrá agregar una descripción, en caso de ser necesario, pero es opcional.',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '#capacitacion-resource',
          popover: {
            title: 'Crear material',
            description:
              'También le podrá asignar una capacitación, y con ella, las fases y puestos de trabajo de ser necesario.',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '#step-1',
          popover: {
            title: 'Editor de material',
            description:
              'En esta sección, usted puede crear la visual de su material. Agregar títulos, descripciones, imágenes, entre otros.',
            side: 'left',
            align: 'start',
          },
        },
        {
          element: '.p-editor-toolbar',
          popover: {
            title: 'Toolbar de Edición',
            description:
              'Use el toolbar de edición con sus diferentes componentes para modificar el texto.',
            side: 'top',
            align: 'center',
          },
        },
        {
          element: '#adjuntos',
          popover: {
            title: 'Agregar recursos',
            description:
              'También cuenta con la opción de agregar recursos, y añadirlos en su template principal, usando este botón:',
            side: 'top',
            align: 'center',
            onNextClick: () => {
              setTimeout(() => {
                driverObj.moveNext();
              }, 50);
            },
          },
        },
        {
          element: '.p-dialog',
          popover: {
            title: 'Popup diálogo',
            description:
              'Se desplegará un diálogo tipo popup, donde usted podrá seleccionar algún recurso adicional a agregar',
            side: 'left',
            align: 'start',
            onPrevClick: () => {
              driverObj.movePrevious();
            },
          },
        },
        {
          element: '#videos',
          popover: {
            title: 'Agregar recursos',
            description:
              'O también agregar videos de url externas (como YouTube), tocando sobre este botón.',
            side: 'left',
            align: 'start',
            onPrevClick: () => {
              driverObj.movePrevious();
            },
          },
        },
        {
          popover: {
            title: 'Agregar material',
            description:
              'Recuerde que una vez cargado el mismo, deberá ser aprobado para finalizar su alta.',
            side: 'left',
            align: 'start',
            onPrevClick: () => {
              driverObj.movePrevious();
            },
          },
        },
      ],
      onDestroyed: () => {},
    });

    driverObj.drive();
  }
}
